import { render, staticRenderFns } from "./MyRcmd.vue?vue&type=template&id=2ba3cea1&scoped=true"
import script from "./MyRcmd.vue?vue&type=script&lang=js"
export * from "./MyRcmd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba3cea1",
  null
  
)

export default component.exports